import axios from "axios";
import { BACKEND_URL } from "../backendURL";



class DiasporaReferenceService {

    getCountries(token) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const apiUrl = BACKEND_URL + "/api/patronage/country-emigrant/";
        return axios.get(apiUrl, config);
    };


    getReferenceTypes(token) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const apiUrl = BACKEND_URL + "/api/patronage/diaspora-reference-types/";
        return axios.get(apiUrl, config);
    };


    getMyReferences(token, filters) {
        const searchFilters = filters.searchFilters;
        const pagination = filters.pagination;
        const limit = pagination.pageSize;
        const offset = pagination.pageSize * (pagination.currentPage - 1);
        const params = { ...searchFilters, offset: offset, limit: limit };

        const config = {
            headers: {
                'Authorization': "Token " + token
            },
            params: params
        };

        const apiUrl = BACKEND_URL + "/api/patronage/my-diaspora-references/";
        return axios.get(apiUrl, config);
    };


    searchVoter(token, filters) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
            params: filters
        };

        const apiUrl = BACKEND_URL + "/api/patronage/diaspora-voter-search/";
        return axios.get(apiUrl, config);
    };


    register(token, data) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const apiUrl = BACKEND_URL + "/api/patronage/register-diaspora-reference/";
        return axios.post(apiUrl, data, config);
    };


    updateData(token, data, referenceId) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const apiUrl = BACKEND_URL + "/api/patronage/diaspora-reference/" + referenceId + "/";
        return axios.put(apiUrl, data, config);
    };


    updateVotingStatus(token, data, referenceId) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const apiUrl = BACKEND_URL + "/api/patronage/update-diaspora-reference-status/" + referenceId + "/";
        return axios.put(apiUrl, data, config);
    };


    delete(token, referenceId) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const apiUrl = BACKEND_URL + "/api/patronage/diaspora-reference/" + referenceId + "/";
        return axios.delete(apiUrl, config);
    };

}

export default new DiasporaReferenceService();